import React from "react";
import { Row, Col, Container, Card } from "react-bootstrap";
import InvoiceTab from "./invoiceTab";

const InvoiceLayout = ({
  items,
  itemStack,
  type,
  tabs,
  print,
  pdf,
  header,
}) => {
  return (
    <Container fluid className="p-3" style={{ height: "100vh" }}>
      <Row className="h-100">
        {itemStack && (
          <Col lg={3} md={3} xs={12} className="h-100">
            <Card className="border h-100" style={{ borderRadius: "5px", overflowY: "auto" }}>
              {itemStack}
            </Card>
          </Col>
        )}

        <Col
          lg={itemStack ? 9 : 12}
          md={9}
          xs={12}
          className="border h-100"
          style={{ background: "white", overflowY: "auto" }}
        >
          {header}
          <InvoiceTab print={print} pdf={pdf} tabs={tabs} type={type} />
        </Col>
      </Row>
    </Container>
  );
};

export default InvoiceLayout;
